import type { TDaDataValuesWithEvent, TInput } from '../../../helpers/models';

const patterns = {
    inn: '^\\d+$',
};

const getPatternByType = (type = '') => patterns[type as keyof typeof patterns];

/**
 * Проверка значения инпута на корректность. Значение корректно, если:
 * 1) Оно пустое
 * 2) Непустое, но регулярка не установлена
 * 3) Непустое и соответствует регулярке
 *
 * @param value - значение, если есть
 * @param regExp - регулярное выражение, если есть
 */
const checkValue = (value?: string, regExp?: string) =>
    !value || !regExp || new RegExp(regExp).test(value);

export const getInputHandler =
    ({ input }: TInput, type: string) =>
    (event: TDaDataValuesWithEvent) => {
        const { value } = event;

        const pattern = getPatternByType(type);

        if (checkValue(value, pattern)) {
            input.onChange(value);
        }
    };
